import { Outlet } from "react-router-dom";
import { Flex } from "flux";
import LeftNav from "../components/left-navigation";

function InternalApp() {
  return (
    <Flex height="100vh" width="100%">
      <Flex flexShrink={0} sx={{ overflowY: "auto" }}>
        <LeftNav />
      </Flex>
      <Flex width="100%" flexDirection="column" sx={{ minWidth: 0 }}>
        {/* Names the container the shared page primitives size themselves against. Without it their
            app-content container queries never match and every page is stuck at the narrow defaults. */}
        <Flex
          className="@container/app-content"
          height="100%"
          flexDirection="column"
          pb="16px"
          box-sizing="border-box"
          sx={{ overflowY: "auto" }}
        >
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default InternalApp;
